/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {SimilarCompanyState} from "./similarCompanyState.zod";

export const similarLeadMatchCompanyNameScoreMin = 0;
export const similarLeadMatchCompanyNameScoreMax = 100;

export const similarLeadMatchWebsiteScoreMin = 0;
export const similarLeadMatchWebsiteScoreMax = 100;

export const similarLeadMatchOverallScoreMin = 0;
export const similarLeadMatchOverallScoreMax = 100;

export const SimilarLeadMatch = zod.object({
  entityType: zod.enum(["LEAD"]),
  entityId: zod.uuid(),
  state: SimilarCompanyState,
  companyName: zod.string(),
  websiteUrl: zod.string().nullable(),
  companyNameScore: zod
    .int()
    .min(similarLeadMatchCompanyNameScoreMin)
    .max(similarLeadMatchCompanyNameScoreMax),
  websiteScore: zod
    .int()
    .min(similarLeadMatchWebsiteScoreMin)
    .max(similarLeadMatchWebsiteScoreMax)
    .nullable(),
  overallScore: zod.int().min(similarLeadMatchOverallScoreMin).max(similarLeadMatchOverallScoreMax),
});

export type SimilarLeadMatch = zod.input<typeof SimilarLeadMatch>;
export type SimilarLeadMatchOutput = zod.output<typeof SimilarLeadMatch>;
